module.exports = __webpack_public_path__ + "fonts/3bf897e.otf";